import {
  Box,
  Button,
  Flex,
  FormControl,
  FormErrorMessage,
  HStack,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Select,
  Text,
  useToast
} from "@chakra-ui/react";
import { useFormik } from "formik";
import { useEffect, useRef, useState } from "react";

import { useNavigate } from "react-router-dom";
import {
  ICourseSession,
  ICourseTerm,
} from "../../../models/admin/courseTermSession.model";
import { ICenter } from "../../../models/centers.model";
import { IAvailableCourse } from "../../../models/trainee-course.model";
import AdminHelpers from "../../../services/admin/admin.service";
import { getLocalUserProfile } from "../../../services/auth.service";
import courseEnrolmentService from "../../../services/course-enrolment.service";
import coursesService from "../../../services/courses.service";

export const ForceEnrolmentModal: React.FC<any> = ({
  isOpen,
  onClosed,
  isEnrol = false,
  data,
  reload,
}: {
  isEnrol: boolean;
  isOpen: any;
  onClosed: any;
  data: string;
  reload: any;
}) => {
  const toast = useToast();
  const cancelRef = useRef().current;
  const [traineeId, setTraineeId] = useState<string | undefined>();
  const [session, setSession] = useState<ICourseSession[]>([]);
  const [term, setTerms] = useState<ICourseTerm[]>([]);
  const [userid, setUserId] = useState<number>();
  const [availableCourses, setAvailableCourses] = useState<IAvailableCourse[]>(
    []
  );
  const [centerss, setCenters] = useState<ICenter[]>([]);
  const [paymentsMode, setPaymentsMode] = useState<any[]>([]);
  const navigate = useNavigate();

  useEffect(() => {
    if (data) setTraineeId(data);
    const user = getLocalUserProfile();
    if (user) setUserId(user.id);
    AdminHelpers.getSessions()
      .then((response) => {
        setSession(response.data);
      })
      .catch((err) => err);
    AdminHelpers.getTerms()
      .then((response) => {
        setTerms(response.data);
      })
      .catch((err) => err);
    AdminHelpers.getAllCenters()
      .then((response) => {
        setCenters(response.data.data);
        console.log(response.data.data, "Eyoooo");
      })
      .catch((err) => err);

    coursesService
      .getAvailableCourses()
      .then((response) => {
        const availablecourses: IAvailableCourse[] = response;
        const realCourses = availablecourses.filter(
          (each) => each.course !== null
        );
        setAvailableCourses(realCourses);
      })
      .catch((err) => err);

    const paymentsMode = [
      {
        id: "1",
        title: "Full",
      },
      {
        id: "2",
        title: "Installment",
      },
    ];
    setPaymentsMode(paymentsMode);
  }, []);

  const formik = useFormik({
    validate: (values: any) => {
      const errors: any = {};
      if (!values.center1) {
        errors.center1 = "center1  required";
      }
      if (values.center1.toString() == values.center2.toString()) {
        errors.center2 = "Please select another center!";
      }

      return errors;
    },
    initialValues: {
      center1: "",
      center2: "",
      session: "",
      term: "",
      course: "",
      payment_mode: "",
    },
    onSubmit: async (values) => {
      try {
        const enroltraineedto: any = {
          centre_1_id: values.center1,
          centre_2_id: "",
          course_session_id: values.session,
          course_term_id: values.term,
          enrolled_by: userid,
          force_enrol: true,
          trainee_id: traineeId,
          payment_mode: values.payment_mode,
        };
        const enroltrainee = await courseEnrolmentService.enrolCourse(
          enroltraineedto,
          values.course
        );

        if (enroltrainee) {
          toast({
            title: "Course Enrolment",
            description: "Course Enroled Successfully",
            status: "success",
            duration: 2000,
          });
          reload();
          onClosed();
        }
      } catch (error: any) {
        toast({
          title: "Course Enrolment",
          description: `${error.response.data.message}`,
          status: "error",
        });
      }
    },
  });

  return (
    <>
      <Modal
        isOpen={isOpen && isEnrol}
        onClose={onClosed}
        scrollBehavior="inside"
        closeOnOverlayClick={true}
        size="sm"
      >
        <ModalOverlay />
        <ModalContent borderRadius={5}>
          <ModalHeader>
            {
              <Text
                fontSize="22px"
                fontWeight="700"
                textTransform="none"
                color="#2B2B2B"
              >
                Course Enrolment
              </Text>
            }
          </ModalHeader>
          <ModalCloseButton size="md" />
          <ModalBody pb={6}>
            <Box>
              <form onSubmit={formik.handleSubmit}>
                <FormControl
                  mb="26px"
                  isInvalid={
                    formik.errors.course && formik.touched.course ? true : false
                  }
                >
                  <Select
                    variant="outline"
                    bg="inputText.500"
                    size="md"
                    placeholder="Select course"
                    value={formik.values.course}
                    name="course"
                    onChange={formik.handleChange}
                    fontSize="14px"
                    color="brand.subtitle"
                  >
                    {availableCourses.map((each, index) => (
                      <option key={index} value={each.course.uuid}>
                        {" "}
                        {each.course ? each.course.name : "nil"}{" "}
                      </option>
                    ))}
                  </Select>
                  <FormErrorMessage fontSize={12}>
                    {formik.errors.course}
                  </FormErrorMessage>
                </FormControl>
                <FormControl
                  mb="26px"
                  isInvalid={
                    formik.errors.session && formik.touched.session
                      ? true
                      : false
                  }
                >
                  <Select
                    variant="outline"
                    bg="inputText.500"
                    size="md"
                    placeholder="Select session"
                    value={formik.values.session}
                    name="session"
                    onChange={formik.handleChange}
                    fontSize="14px"
                    color="brand.subtitle"
                  >
                    {session.map((each, index) => (
                      <option key={index} value={each.id}>
                        {" "}
                        {each.title}{" "}
                      </option>
                    ))}
                  </Select>
                  <FormErrorMessage fontSize={12}>
                    {formik.errors.session}
                  </FormErrorMessage>
                </FormControl>
                <FormControl
                  mb="26px"
                  isInvalid={
                    formik.errors.term && formik.touched.term ? true : false
                  }
                >
                  <Select
                    variant="outline"
                    bg="inputText.500"
                    size="md"
                    placeholder="Select term"
                    value={formik.values.term}
                    name="term"
                    onChange={formik.handleChange}
                    fontSize="14px"
                    color="brand.subtitle"
                  >
                    {term.map((each, index) => (
                      <option key={index} value={each.id}>
                        {" "}
                        {each.title}{" "}
                      </option>
                    ))}
                  </Select>
                  <FormErrorMessage fontSize={12}>
                    {formik.errors.term}
                  </FormErrorMessage>
                </FormControl>
                <FormControl
                        mb="26px"
                  mt={4}
                  isInvalid={
                    formik.errors.center1 && formik.touched.center1
                      ? true
                      : false
                  }
                >
                  <Select
                    variant="outline"
                    bg="inputText.500"
                    size="md"
                    placeholder="Select final center"
                    value={formik.values.center1}
                    name="center1"
                    onChange={formik.handleChange}
                    fontSize="14px"
                    color="brand.subtitle"
                  >
                    {centerss &&
                      centerss.map((each, index) => (
                        <option key={index} value={each.id}>
                          {" "}
                          {each.name}{" "}
                        </option>
                      ))}
                  </Select>

                  <FormErrorMessage fontSize={12}>
                    {formik.errors.center1}
                  </FormErrorMessage>
                </FormControl>

                <FormControl
                  mt={4}
                  isInvalid={
                    formik.errors.payment_mode && formik.touched.payment_mode
                      ? true
                      : false
                  }
                >
                  <Select
                    variant="outline"
                    bg="inputText.500"
                    size="md"
                    placeholder="Select payment mode"
                    value={formik.values.payment_mode}
                    name="payment_mode"
                    onChange={formik.handleChange}
                    fontSize="14px"
                    color="brand.subtitle"
                  >
                    {paymentsMode &&
                      paymentsMode.map((each, index) => (
                        <option key={index} value={each.title}>
                          {" "}
                          {each.title}{" "}
                        </option>
                      ))}
                  </Select>

                  <FormErrorMessage fontSize={12}>
                    {formik.errors.payment_mode}
                  </FormErrorMessage>
                </FormControl>

                <Flex mt={12} justifyContent="end">
                  <HStack>
                    <Button
                      size="sm"
                      px={6}
                      fontSize={12}
                      ref={cancelRef}
                      onClick={() => onClosed()}
                    >
                      Cancel
                    </Button>
                    <Button
                      colorScheme="red"
                      type="submit"
                      isLoading={formik.isSubmitting}
                      size="sm"
                      px={6}
                      fontSize={12}
                    >
                      {" "}
                      Enrol
                    </Button>
                  </HStack>
                </Flex>
              </form>
            </Box>
          </ModalBody>

          <ModalFooter></ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};
